import React from "react";
import styled from "styled-components";
import BaseComponent from "../../BaseComponent.js";
import NanoFlex from "../../Global/NanoFlex.js";
import Type from "../../Global/Typography.js";

//IMGS
import RitaSantos from "../../Global/images/RitaSantos.png";
import RitaSantosHover from "../../Global/images/RitaSanosHover.png";
import TeresaOliveira from "../../Global/images/TeresaOliveira.png";
import TeresaOliveiraHover from "../../Global/images/TeresaOliveiraHover.png";
import CatarinaDuarte from "../../Global/images/CatarinaDuarte.png";
import CatarinaDuarteHover from "../../Global/images/CatarinaDuarteHover.png";
import BeatrizMoreira from "../../Global/images/BeatrizMoreira.png";
import BeatrizMoreiraHover from "../../Global/images/BeatrizMoreiraHover.png";
import JoanaDias from "../../Global/images/JoanaDias.png";
import JoanaDiasHover from "../../Global/images/JoanaDiasHover.png";
import DianaSousa from "../../Global/images/DianaSousa.png";
import DianaSousaHover from "../../Global/images/DianaSousaHover.png";
import CarolinaSilva from "../../Global/images/CarolinaSilva.png";
import CarolinaSilvaHover from "../../Global/images/CarolinaSilvaHover.png";
import CesarMarques from "../../Global/images/CesarMarques.png";
import CesarMarquesHover from "../../Global/images/CesarMarquesHover.png";
import JulianaPereira from "../../Global/images/JulianaPereira.png";
import JulianaPereiraHover from "../../Global/images/JulianaPereiraHover.png";

const StyledTeamChaseUp = styled(NanoFlex)`
  padding: 0 100px 0 100px;
  gap: 30px;

  .teamTitle {
    gap: 24px;

    @media only screen and (max-width: 1024px) {
      gap: 16px;
    }

    h3 {
      font-weight: 500;
    }
  }

  .teamCardsFlex {
    flex-wrap: wrap;
    gap: 30px;

    .singleCard {
      flex: 1 calc(33.33% - 30px);
      width: calc(33.33% - 30px);
      gap: 10px;
      height: 515px;

      .teamPhoto {
        overflow: hidden;
        border-radius: 10px;
        flex-grow: 1;
        background-color: ${(props) => props.theme.color.primaryColors.transparencyPurple};

        img {
          height: 100%;
          width: 100%;
          z-index: 1;
          position: relative;
          transition: ${(props) => props.theme.transition};
          object-fit: cover;
        }

        .hoverImage {
          display: none;
          z-index: 2;
        }

        &:hover {
          .standardImage {
            display: none;
          }
          .hoverImage {
            display: flex;
            transition: ${(props) => props.theme.transition};
          }
        }
      }
      .teamMemberName {
        height: auto;
        p {
          font-weight: 500;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }

  @media only screen and (max-width: 1450px) {
    padding: 0 50px 0 50px;

    .teamCardsFlex {
      .singleCard {
        height: 364px;
      }
    }
  }

  /* TABLETS */
  @media only screen and (max-width: 1024px) {
    padding: 0 30px 0 30px;
  }

  @media only screen and (max-width: 815px) {
    padding: 0 10px 0 10px;
    gap: 24px;

    .teamCardsFlex {
      gap: 16px;

      .singleCard {
        height: 200px;

        .teamPhoto {
          border-radius: 5px;
        }
      }
    }
  }

  /* MOBILE SMALL*/
  @media only screen and (max-width: 390px) {
    .teamCardsFlex {
      .singleCard {
        width: calc(50% - 16px);
        max-width: calc(50% - 8px);
        flex: 1 calc(50% - 16px);
      }
    }
  }
`;

export default class TeamChaseUp extends BaseComponent {
  componentDidMount() {
    super.componentDidMount();
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  render() {
    return (
      <StyledTeamChaseUp flexDirection={"column"} justifyContent="flex-start" alignItems={"flex-start"}>
        <NanoFlex className="teamTitle" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
          <Type.h3>{this.translation.aboutUs.makingHappen}</Type.h3>
          <Type.p>{this.translation.aboutUs.meetTheTeam}</Type.p>
        </NanoFlex>

        <NanoFlex className="teamCardsFlex" justifyContent="flex-start">
          <NanoFlex className="singleCard" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
            <NanoFlex className="teamPhoto">
              <img src={RitaSantos} alt="Rita Santos" className="standardImage" />
              <img src={RitaSantosHover} alt="Rita Santos" className="hoverImage" />
            </NanoFlex>
            <NanoFlex className="teamMemberName" justifyContent="flex-start">
              <Type.p>Rita Santos</Type.p>
            </NanoFlex>
          </NanoFlex>
          <NanoFlex className="singleCard" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
            <NanoFlex className="teamPhoto">
              <img src={TeresaOliveira} alt="Teresa Oliveira" className="standardImage" />
              <img src={TeresaOliveiraHover} alt="Teresa Oliveira" className="hoverImage" />
            </NanoFlex>
            <NanoFlex className="teamMemberName" justifyContent="flex-start">
              <Type.p>Teresa Oliveira</Type.p>
            </NanoFlex>
          </NanoFlex>
          <NanoFlex className="singleCard" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
            <NanoFlex className="teamPhoto">
              <img src={CatarinaDuarte} alt="Catarina Duarte" className="standardImage" />
              <img src={CatarinaDuarteHover} alt="Catarina Duarte" className="hoverImage" />
            </NanoFlex>
            <NanoFlex className="teamMemberName" justifyContent="flex-start">
              <Type.p>Catarina Duarte</Type.p>
            </NanoFlex>
          </NanoFlex>
          <NanoFlex className="singleCard" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
            <NanoFlex className="teamPhoto">
              <img src={BeatrizMoreira} alt="Beatriz Moreira" className="standardImage" />
              <img src={BeatrizMoreiraHover} alt="Beatriz Moreira" className="hoverImage" />
            </NanoFlex>
            <NanoFlex className="teamMemberName" justifyContent="flex-start">
              <Type.p>Beatriz Moreira</Type.p>
            </NanoFlex>
          </NanoFlex>
          <NanoFlex className="singleCard" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
            <NanoFlex className="teamPhoto">
              <img src={JoanaDias} alt="Joana Dias" className="standardImage" />
              <img src={JoanaDiasHover} alt="Joana Dias" className="hoverImage" />
            </NanoFlex>
            <NanoFlex className="teamMemberName" justifyContent="flex-start">
              <Type.p>Joana Dias</Type.p>
            </NanoFlex>
          </NanoFlex>
          <NanoFlex className="singleCard" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
            <NanoFlex className="teamPhoto">
              <img src={DianaSousa} alt="Diana Sousa" className="standardImage" />
              <img src={DianaSousaHover} alt="Diana Sousa" className="hoverImage" />
            </NanoFlex>
            <NanoFlex className="teamMemberName" justifyContent="flex-start">
              <Type.p>Diana Sousa</Type.p>
            </NanoFlex>
          </NanoFlex>
          <NanoFlex className="singleCard" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
            <NanoFlex className="teamPhoto">
              <img src={CarolinaSilva} alt="Carolina Silva" className="standardImage" />
              <img src={CarolinaSilvaHover} alt="Carolina Silva" className="hoverImage" />
            </NanoFlex>
            <NanoFlex className="teamMemberName" justifyContent="flex-start">
              <Type.p>Carolina Silva</Type.p>
            </NanoFlex>
          </NanoFlex>
          <NanoFlex className="singleCard" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
            <NanoFlex className="teamPhoto">
              <img src={CesarMarques} alt="César Marques" className="standardImage" />
              <img src={CesarMarquesHover} alt="César Marques" className="hoverImage" />
            </NanoFlex>
            <NanoFlex className="teamMemberName" justifyContent="flex-start">
              <Type.p>César Marques</Type.p>
            </NanoFlex>
          </NanoFlex>
          <NanoFlex className="singleCard" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
            <NanoFlex className="teamPhoto">
              <img src={JulianaPereira} alt="Juliana Pereira" className="standardImage" />
              <img src={JulianaPereiraHover} alt="Juliana Pereira" className="hoverImage" />
            </NanoFlex>
            <NanoFlex className="teamMemberName" justifyContent="flex-start">
              <Type.p>Juliana Pereira</Type.p>
            </NanoFlex>
          </NanoFlex>
        </NanoFlex>
      </StyledTeamChaseUp>
    );
  }
}
